module.exports = __webpack_public_path__ + "static/media/homepage-section-6-phone-6.0517e8d8.png";